// NodeHandlerContext.js
import { createContext } from 'react';

export const NodeHandlerContext = createContext(null);
